// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LyHG","type":"styles_type__1ADXF","choices":"styles_choices__1bkjT"};